export const SEARCH_DEBOUNCE_DELAY = 500;
